import { render, staticRenderFns } from "./ViewTravelLeisure.vue?vue&type=template&id=46bf341e&scoped=true"
import script from "./ViewTravelLeisure.vue?vue&type=script&lang=js"
export * from "./ViewTravelLeisure.vue?vue&type=script&lang=js"
import style0 from "./ViewTravelLeisure.vue?vue&type=style&index=0&id=46bf341e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bf341e",
  null
  
)

export default component.exports